import * as Icons from '@lucide/svelte';
import type { IconType } from '../../components/icons/icons.types';

/** The icons of the database page, in one place: PageService takes them from here. */
class DatabaseIconsClass {
    public readonly Database: IconType = Icons.Database;
}

export const DatabaseIcons = new DatabaseIconsClass();
